import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  consolidationContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2.25),
    padding: theme.spacing(1.5),
    borderBottom: `1px solid ${theme.palette.wallet.latestMovements.borderBottom}`,
  },
  movementsIcon: {
    paddingLeft: 1,
    borderRadius: '100%',
    '&.material-icons': {
      fontSize: theme.typography.pxToRem(25),
      color: theme.palette.wallet.latestMovements.icon.default.icon,
      backgroundColor: theme.palette.wallet.latestMovements.icon.default.color,
    },
    '&[data-transaction-type="debit"]': {
      '&.material-icons': {
        color: theme.palette.wallet.latestMovements.icon.debit.icon,
        backgroundColor: theme.palette.wallet.latestMovements.icon.debit.color,
      },
    },
    '&[data-transaction-type="credit"]': {
      '&.material-icons': {
        color: theme.palette.wallet.latestMovements.icon.credit.icon,
        backgroundColor: theme.palette.wallet.latestMovements.icon.credit.color,
      },
    },
  },
  verticalContainer: {
    display: 'flex',
    gap: theme.spacing(0.5),
    flexDirection: 'column',
  },
  type: {
    lineHeight: 1.08,
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.wallet.latestMovements.textColor,
  },
  description: {
    lineHeight: 1.08,
    fontSize: theme.typography.pxToRem(16),
  },
  date: {
    lineHeight: 1.08,
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.wallet.latestMovements.textColor,
  },
  hour: {
    lineHeight: 1.08,
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.wallet.latestMovements.textColor,
  },
  chip: {
    flex: 0,
    width: 'fit-content',
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.spacing(0.5),
    backgroundColor: theme.palette.wallet.chip.color,
    '& .MuiChip-label': {
      padding: 0,
      lineHeight: 1,
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.wallet.chip.textColor,
    },
    '&[data-modality="C"]': {
      backgroundColor: theme.palette.wallet.chip.cashbackColor,
      '& .MuiChip-label': {
        color: theme.palette.wallet.chip.cashbackTextColor,
      },
    },
    '&[data-modality="P"]': {
      backgroundColor: theme.palette.wallet.chip.pointsColor,
      '& .MuiChip-label': {
        color: theme.palette.wallet.chip.pointsTextColor,
      },
    },
  },
  amount: {
    fontWeight: 500,
    lineHeight: 1.08,
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.wallet.latestMovements.amountColor,
  },
}))
